/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsV1SweepTargetState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_V1_SWEEP_TARGET_STATE_ENTITY_NAME = 'ixc.sweeps.v1.SweepTarget';
export const ixcSweepsV1SweepTargetStateEntity = new schema.Entity<IxcSweepsV1SweepTargetState>(IXC_SWEEPS_V1_SWEEP_TARGET_STATE_ENTITY_NAME, {}, { idAttribute: 'sweepTargetId' });

